import { render, staticRenderFns } from "./OutBoundDetail.vue?vue&type=template&id=48a8323c&"
import script from "./OutBoundDetail.vue?vue&type=script&lang=ts&"
export * from "./OutBoundDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OutBoundDetail.vue?vue&type=style&index=0&id=48a8323c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports